// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"ModalHeader_modal-header__2VPTC"};